/** @jsx jsx */
import { object, string } from 'prop-types'
import { Flex, jsx } from 'theme-ui'
import CalendarArticleTable from './CalendarArticleTable'

const CalendarArticle = ({ data, id }) => {
  const { table, isCalendarView } = data.fields
  return (
    <Flex
      id={id}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <CalendarArticleTable
        articleTable={table}
        isCalendarView={isCalendarView}
      />
    </Flex>
  )
}

CalendarArticle.propTypes = {
  data: object,
  id: string,
}

export default CalendarArticle
